<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">المناطق</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">المناطق</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="checkAccess('regions_create')" class="row">
          <div class="col text-end">
            <router-link to="/regions" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة منطقة
            </router-link>
          </div>
        </div>

        <div v-if="isLoading" class="text-center align-content-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center mb-4 mt-5">
          <div class="col-12 col-md-11">
            <errorAlert v-if="hasError" :alertMessage= "message" />
            <table class="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">الاسم - عربي</th>
                  <th scope="col">الاسم - إنجليزي</th>
                  <th scope="col">الحاله</th>
                  <th scope="col">اخر تحديث</th>
                  <th scope="col">التعديل</th>
                  <th v-if="checkAccess('regions_delete')" scope="col">الحذف</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in rows" :key="index">
                  <td class="counter"></td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.nameEn }}</td>
                  <td>{{ (row.isActive)? 'نشط' : 'غير نشط' }}</td>
                  <td>{{ $shortDate(row.updatedAt) }}</td>
                  <td>
                    <router-link v-if="checkAccess('regions_update')" :to="'/regionsupdate/'+row.id">
                      <i class="bi bi-card-list"></i>
                    </router-link>
                    <router-link v-else :to="'/regionsRead/'+row.id">
                      <i class="fa-regular fa-eye"></i>
                    </router-link>
                  </td>
                  <td v-if="checkAccess('regions_delete')">
                    <a @click.prevent="deleteItem(index, row.id)">
                      <i class="bi bi-archive text-red pointer-mouse"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { toast, checkAccess } from '@/helpers/tools';
export default {
  name: "regionsview",
  data(){
    return {
      hasError: false,
      message: "",
      isLoading: false,
      rows: [],
    }
  },
  methods: {
    checkAccess, 
    regionList() {
      this.hasError = false;
      this.isLoading = true;
      this.$http.get('/api/admin/regions/list').then(res => {
        this.isLoading = false;
        this.rows = res.data.regions;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scroll(0,0);
        this.isLoading = false;
      })
    },

    deleteItem(index, id) {
      this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/api/admin/regions/delete/${id}`).then(({data}) => {
            this.rows.splice(index, 1);
            toast('تم حذف السجل بنجاح', 'success');
          }).catch(err => {
            toast('غير قادر على حذف السجل');
          });
        }
      });
    },
  },
  created() {
    this.regionList();
  }
}
</script>